module.exports = __webpack_public_path__ + "img/folder.c9993259.svg";